import { render, staticRenderFns } from "./SignificantEventCreate.vue?vue&type=template&id=23eba3dc&scoped=true&"
import script from "./SignificantEventCreate.vue?vue&type=script&lang=js&"
export * from "./SignificantEventCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eba3dc",
  null
  
)

export default component.exports